"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
interface ShimmeringTextProps {
  text: string;
  /** Duration of one shimmer sweep in seconds */
  duration?: number;
  /** Per-character wave effect (y-bounce). Plays once per mount. */
  wave?: boolean;
  /** Base text color */
  color?: string;
  /** Highlight color during shimmer */
  shimmeringColor?: string;
  /** Seconds to wait between shimmer cycles (wave=false only) */
  interval?: number;
  className?: string;
}
export function ShimmeringText(t0) {
  const $ = _c(18);
  const {
    text,
    duration: t1,
    wave: t2,
    color: t3,
    shimmeringColor: t4,
    interval: t5,
    className
  } = t0;
  const duration = t1 === undefined ? 1 : t1;
  const wave = t2 === undefined ? false : t2;
  const color = t3 === undefined ? "#374151" : t3;
  const shimmeringColor = t4 === undefined ? "#9ca3af" : t4;
  const interval = t5 === undefined ? 5 : t5;
  if (wave) {
    let t6;
    if ($[0] !== className || $[1] !== color || $[2] !== duration || $[3] !== shimmeringColor || $[4] !== text) {
      const characters = text.split("");
      const waveDuration = duration * 0.6;
      let t7;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          display: "inline-flex"
        };
        $[6] = t7;
      } else {
        t7 = $[6];
      }
      t6 = <span className={className} style={t7}>{characters.map((char, i) => <motion.span key={`${i}-${char}`} style={{
          display: "inline-block"
        }} initial={{
          color,
          y: 0,
          scale: 1
        }} animate={{
          color: [color, shimmeringColor, color],
          y: [0, -1.5, 0],
          scale: [1, 1.04, 1]
        }} transition={{
          duration: waveDuration,
          delay: i * duration / characters.length,
          ease: "easeInOut"
        }}>{char === " " ? "\xA0" : char}</motion.span>)}</span>;
      $[0] = className;
      $[1] = color;
      $[2] = duration;
      $[3] = shimmeringColor;
      $[4] = text;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    return t6;
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      backgroundPosition: ["100% 0", "0% 0"]
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== duration || $[9] !== interval) {
    t7 = {
      duration,
      repeat: Infinity,
      repeatDelay: interval,
      ease: "linear"
    };
    $[8] = duration;
    $[9] = interval;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `linear-gradient(90deg, ${color} 0%, ${color} 40%, ${shimmeringColor} 50%, ${color} 60%, ${color} 100%)`;
  let t9;
  if ($[11] !== t8) {
    t9 = {
      backgroundImage: t8,
      backgroundSize: "300% 100%",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text"
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== className || $[14] !== t7 || $[15] !== t9 || $[16] !== text) {
    t10 = <motion.span className={className} animate={t6} transition={t7} style={t9}>{text}</motion.span>;
    $[13] = className;
    $[14] = t7;
    $[15] = t9;
    $[16] = text;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}